var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6817_20578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6359 10.5618C15.8995 8.29815 15.8995 4.62808 13.6359 2.36447C11.3723 0.100842 7.70223 0.100842 5.43859 2.36447L4.99663 2.80644C4.63949 3.16355 4.54689 3.68378 4.87296 4.06941C4.98866 4.20628 5.13239 4.36375 5.31049 4.54188C5.48863 4.72001 5.64613 4.86371 5.78296 4.97941C6.16863 5.30548 6.68883 5.21288 7.04593 4.85578L7.48792 4.41378C8.61972 3.28198 10.4548 3.28198 11.5866 4.41378C12.7184 5.54561 12.7184 7.38065 11.5866 8.51245L11.1446 8.95441C10.7875 9.31155 10.6949 9.83175 11.021 10.2174C11.1367 10.3542 11.2804 10.5117 11.4585 10.6898C11.6366 10.868 11.7941 11.0117 11.9309 11.1274C12.3166 11.4535 12.8368 11.3609 13.1939 11.0037L13.6359 10.5618ZM5.43826 10.5619C4.87236 9.99598 4.87236 9.07848 5.43826 8.51255L8.51226 5.43858C9.07816 4.87265 9.99569 4.87265 10.5616 5.43858C11.1275 6.00448 11.1275 6.92198 10.5616 7.48788L7.48759 10.5619C6.92169 11.1278 6.00419 11.1278 5.43826 10.5619ZM2.36471 13.6357C0.101086 11.372 0.101086 7.70198 2.36471 5.43838L2.80669 4.99638C3.1638 4.63928 3.68403 4.54668 4.06966 4.87275C4.20653 4.98845 4.36399 5.13215 4.54213 5.31028C4.72026 5.48841 4.86396 5.64588 4.97966 5.78275C5.30573 6.16838 5.21313 6.68861 4.85603 7.04571L4.41403 7.48768C3.28223 8.61951 3.28223 10.4545 4.41403 11.5863C5.54586 12.7182 7.38089 12.7182 8.51269 11.5863L8.95466 11.1444C9.31179 10.7873 9.83199 10.6946 10.2177 11.0207C10.3545 11.1364 10.512 11.2801 10.6901 11.4583C10.8682 11.6364 11.012 11.7939 11.1277 11.9307C11.4537 12.3164 11.3611 12.8366 11.004 13.1937L10.562 13.6357C8.29839 15.8993 4.62833 15.8993 2.36471 13.6357Z",
    fill: "#0157FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6817_20578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.7a7b7df7d2b63da89cbf0df833db2dbb.svg";
export { ForwardRef as ReactComponent };